import { Instagram, ArrowUpRight } from "lucide-react";
import { REGISTER_URL } from "@/lib/api";
import { LOGO } from "./Nav";
import { Wrap } from "./Motion";

const sponsors = ["Equine Evolve", "ClipMyHorse.TV", "Horse Sport Ireland", "Connolly's RED MILLS", "Dubarry", "Cavan Equestrian"];

export const Footer = () => (
  <footer className="border-t border-[#D4AF37]/15 bg-[#0B1630]" data-testid="site-footer">
    <Wrap className="py-10">
      <p className="eyebrow text-center mb-6">Partners</p>
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-3">
        {sponsors.map((s) => <span key={s} className="font-display text-base lg:text-lg text-[#6F7C97] hover:text-[#F8F6F0] transition-colors duration-300">{s}</span>)}
      </div>
    </Wrap>
    <div className="gold-line" />
    <Wrap className="py-12 grid sm:grid-cols-2 lg:grid-cols-12 gap-8">
      <div className="lg:col-span-5">
        <img src={LOGO} alt="Ballypatrick Auctions" className="h-14 w-auto" loading="lazy" />
        <p className="mt-4 text-sm text-[#AEB7C9] max-w-xs leading-relaxed">Ballypatrick Stables, Co. Tipperary, Ireland.<br />Crafted for the sport. Proven in the ring.</p>
        <a href="https://www.instagram.com/ballypatrick_auctions/" target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase text-[#AEB7C9] hover:text-[#D4AF37] transition-colors" data-testid="footer-instagram-link"><Instagram size={14} /> @ballypatrick_auctions</a>
      </div>
      <nav className="lg:col-span-3 space-y-2.5 text-sm" aria-label="Footer">
        <p className="eyebrow mb-4">Site</p>
        {[["Why Ballypatrick", "#manifesto"], ["Assurance", "#assurance"], ["Collection", "#collection"], ["Transport", "#transport"], ["Archive", "#archive"]].map(([l, h]) => <a key={h} href={h} className="block text-[#AEB7C9] hover:text-[#F8F6F0] transition-colors">{l}</a>)}
      </nav>
      <div className="lg:col-span-4">
        <p className="eyebrow mb-4">Bidding</p>
        <p className="text-sm text-[#AEB7C9] leading-relaxed">Bidding takes place on our secure partner platform. Free registration, two minutes.</p>
        <a href={REGISTER_URL} target="_blank" rel="noreferrer" className="btn-ghost mt-5 !py-3 !px-5" data-testid="footer-register-link">Register to bid <ArrowUpRight size={14} /></a>
      </div>
    </Wrap>
    <Wrap className="pb-8 flex flex-col sm:flex-row justify-between gap-1 text-[11px] text-[#6F7C97]">
      <span>© 2026 Ballypatrick Auctions. All rights reserved.</span>
      <span>Auction V · 28 December 2026</span>
    </Wrap>
  </footer>
);
